const StoreTransferWalletReducers = (state = {}, action) => {
  switch (action.type) {
    case "storeTransferWallet":
      return action.payload;
    case "clearTransferWallet":
      return {};
    default:
      return state;
  }
};
export default StoreTransferWalletReducers;
